
import { initSentry } from './lib/sentry';
initSentry();

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { bindQueryClientToSession, createQueryClient } from '@/lib/query-client';
import { BrowserRouter } from 'react-router-dom';
import { SoberToaster } from './v2/design-system/primitives';
import { ErrorBoundary } from './components/ErrorBoundary';
import { instalarRecargaDeChunk } from './lib/chunk-reload';
import { AppVersionWatcher } from './components/AppVersionWatcher';
import { hasWorkBeforeUnload } from './stores/workDrafts';
import { registerServiceWorker } from './lib/service-worker';
import App from './App';
import './index.css';

// Antes de montar: aba aberta durante um deploy pede pedaço da build anterior e recebe HTML
// onde esperava JavaScript. Recarrega uma vez sozinha em vez de mostrar "Algo deu errado".
instalarRecargaDeChunk(window, sessionStorage, undefined, hasWorkBeforeUnload);
registerServiceWorker();

const queryClient = createQueryClient();
const unbindSessionCache = bindQueryClientToSession(queryClient);
if (import.meta.hot) import.meta.hot.dispose(unbindSessionCache);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
          <AppVersionWatcher />
          <SoberToaster />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
